import { useState } from "react";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

import { useAppDispatch } from "store/store";
import {
  labelLastUpdate,
  labelNome,
  labelOrderBy,
  lessRecent,
  mostRecent,
  nameAsc,
  nameDesc,
} from "_constants";
import { setSortProject } from "store/slicer/GestioneProjectsSlice";

export const InputProjectOrderBy = () => {
  const OrderbyList = [
    {
      label: labelNome,
      code: labelNome,
      items: [
        { label: nameAsc, value: "name,ASC" },
        { label: nameDesc, value: "name,DESC" },
      ],
    },
    {
      label: labelLastUpdate,
      code: labelLastUpdate,
      items: [
        { label: mostRecent, value: "lastUpdate,DESC" },
        { label: lessRecent, value: "lastUpdate,ASC" },
      ],
    },
  ];

  const [selectedType, setSelectedType] = useState(null);

  const dispatch = useAppDispatch();

  const onChangeValue = (event: MultiSelectChangeEvent) => {
    setSelectedType(event.value);

    dispatch(setSortProject(event.value ?? null));
  };

  return (
    <Dropdown
      value={selectedType}
      onChange={onChangeValue}
      options={OrderbyList}
      optionLabel="label"
      placeholder={labelOrderBy}
      showClear={true}
      optionGroupLabel="label"
      optionGroupChildren="items"
      panelClassName="custom-dropdown-order-by"
    />
  );
};
